module.exports = __webpack_public_path__ + "static/media/img_lady.b1b5bb5a.png";